/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type { PlatformDTO } from "../models";
import { PlatformDTOFromJSON, PlatformDTOToJSON } from "../models";

export interface GetAllPlatformsRequest {
  platformId: number;
}

export interface UpdatePlatformRequest {
  platformId: number;
  platformDTO: PlatformDTO;
}

/**
 *
 */
export class PlatformApi extends runtime.BaseAPI {
  /**
   */
  async getAllPlatformsRaw(
    requestParameters: GetAllPlatformsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PlatformDTO>> {
    if (requestParameters.platformId === null || requestParameters.platformId === undefined) {
      throw new runtime.RequiredError(
        "platformId",
        "Required parameter requestParameters.platformId was null or undefined when calling getAllPlatforms."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.platformId !== undefined) {
      queryParameters["platformId"] = requestParameters.platformId;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/api/platforms`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => PlatformDTOFromJSON(jsonValue));
  }

  /**
   */
  async getAllPlatforms(
    requestParameters: GetAllPlatformsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PlatformDTO> {
    const response = await this.getAllPlatformsRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async updatePlatformRaw(
    requestParameters: UpdatePlatformRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters.platformId === null || requestParameters.platformId === undefined) {
      throw new runtime.RequiredError(
        "platformId",
        "Required parameter requestParameters.platformId was null or undefined when calling updatePlatform."
      );
    }

    if (requestParameters.platformDTO === null || requestParameters.platformDTO === undefined) {
      throw new runtime.RequiredError(
        "platformDTO",
        "Required parameter requestParameters.platformDTO was null or undefined when calling updatePlatform."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/api/platforms/{platformId}`.replace(
          `{${"platformId"}}`,
          encodeURIComponent(String(requestParameters.platformId))
        ),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: PlatformDTOToJSON(requestParameters.platformDTO)
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async updatePlatform(
    requestParameters: UpdatePlatformRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.updatePlatformRaw(requestParameters, initOverrides);
  }
}
